import React from 'react';
import PropTypes from 'prop-types';

const Tile = props => {
  const { img, icon, mainText, secondaryText, click } = props;
  return (
    <div className="tiles__item" onClick={click}>
      <div className="tiles__item--outline">
        <div className="tiles__item-text">
          <div className="tiles__item-text--main">{mainText}</div>
          {secondaryText && <div className="tiles__item-text--secondary">{secondaryText}</div>}
        </div>
        <img className="tiles__item-img" src={img} alt="" />
        {icon && <span className="icon-right-arrow" />}
      </div>
    </div>
  );
};

Tile.propTypes = {
  img: PropTypes.string.isRequired,
  mainText: PropTypes.string.isRequired,
  secondaryTex: PropTypes.string,
  click: PropTypes.func,
};

export default Tile;
